import { render, staticRenderFns } from "./HeroVideoItem.vue?vue&type=template&id=56acb628"
import script from "./HeroVideoItem.vue?vue&type=script&lang=js"
export * from "./HeroVideoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports